import React from 'react';
import { Link } from 'react-router-dom';
import '../sidebar/Planos.css';

const PLANOS_ASSINATURA = [
  {
    id: 'basic',
    nome: 'Basic',
    preco: 'R$ 49,90/mês',
    recursos: [
      'Acesso a até 3 usuários',
      'Relatórios básicos',
      'Suporte por email',
      'Armazenamento de 5GB',
      'Integrações básicas'
    ]
  },
  {
    id: 'pro',
    nome: 'Pro',
    preco: 'R$ 99,90/mês',
    destaque: true,
    recursos: [
      'Acesso a até 10 usuários',
      'Relatórios avançados',
      'Suporte prioritário 24/7',
      'Armazenamento de 25GB',
      'Todas as integrações'
    ]
  },
  {
    id: 'premium',
    nome: 'Premium',
    preco: 'R$ 199,90/mês',
    recursos: [
      'Usuários ilimitados',
      'Relatórios personalizados',
      'Gerente de conta dedicado',
      'Armazenamento ilimitado',
      'API completa + Integrações'
    ]
  }
];

export default function LandingPage() {
  return (
    <div style={{ background: '#fff', minHeight: '100vh', overflowX: 'hidden' }}>

      {/* ── Nav header ───────────────────────────────────── */}
      <header style={{
        background: 'linear-gradient(90deg, rgb(235, 133, 0) 0%, rgb(250, 190, 40) 100%)',
        height: 70,
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        justifyContent: 'space-between',
        boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <span style={{
          color: '#fff',
          fontWeight: 800,
          fontSize: 'clamp(18px, 3vw, 24px)',
          letterSpacing: '-0.5px',
          textShadow: '0 1px 4px rgba(0,0,0,0.18)'
        }}>
          S6 Gestão
        </span>

        <div style={{ display: 'flex', gap: 10 }}>
          <Link to="/sidebar/Login" style={{ textDecoration: 'none' }}>
            <button style={{
              padding: '12px 36px',
              fontSize: 16,
              fontWeight: 700,
              background: 'linear-gradient(135deg, rgb(235, 133, 0), rgb(250, 178, 65))',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer'
            }}
            >
              Entrar
            </button>
          </Link>
          <Link to="/sidebar/CriarConta" style={{ textDecoration: 'none' }}>
            <button style={{
              padding: '10px 30px',
              fontSize: 15,
              fontWeight: 700,
              background: 'transparent',
              color: '#fff',
              border: '2px solid rgba(255,255,255,0.9)',
              borderRadius: 8,
              cursor: 'pointer'
            }}
            >
              Criar Conta
            </button>
          </Link>
        </div>
      </header>

      {/* ── Hero ─────────────────────────────────────────── */}
      <section style={{ padding: '28px 24px 32px', textAlign: 'center' }}>
        <h1 style={{
          fontSize: 'clamp(30px, 5vw, 54px)',
          fontWeight: 800,
          color: 'rgb(235, 133, 0)',
          margin: '0 0 12px',
          lineHeight: 1.2
        }}>
          Bem-vindo ao S6 Gestão
        </h1>

        <p style={{
          fontSize: 'clamp(16px, 2vw, 20px)',
          color: '#222',
          lineHeight: 1.75,
          maxWidth: 660,
          margin: '0 auto 10px'
        }}>
          Aqui você vai conseguir direcionar o seu projeto, suas produções,
          gestão financeira, contratos, clientes, estoque e muito mais —
          tudo em um só lugar.
        </p>

        <p style={{ fontSize: 16, color: '#777', margin: '0 0 24px' }}>
          Comece agora e leve sua empresa para o próximo nível.
        </p>

        <Link to="/sidebar/Login" style={{ textDecoration: 'none' }}>
          <button
            style={{
              padding: '14px 44px',
              fontSize: 18,
              fontWeight: 700,
              background: 'linear-gradient(135deg, rgb(235, 133, 0), rgb(250, 178, 65))',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              cursor: 'pointer',
              boxShadow: '0 4px 18px rgba(235,133,0,0.35)'
            }}
          >
            Entrar
          </button>
        </Link>
      </section>

      {/* ── Divider ──────────────────────────────────────── */}
      <div style={{
        height: 2,
        background: 'linear-gradient(90deg, transparent, rgb(235,133,0) 30%, rgb(250,178,65) 70%, transparent)',
        margin: '0 8%'
      }} />

      {/* ── Planos ───────────────────────────────────────── */}
      <section style={{ padding: '28px 24px 48px', background: '#fafafa' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h2 style={{
            fontSize: 'clamp(22px, 3vw, 34px)',
            fontWeight: 700,
            color: '#1a1a1a',
            margin: '0 0 12px'
          }}>
            Configure os planos
          </h2>
          <p style={{ fontSize: 16, color: '#666', margin: 0 }}>
            Escolha o plano ideal para o seu negócio
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 24,
          maxWidth: 1100,
          margin: '0 auto'
        }}>
          {PLANOS_ASSINATURA.map((plano) => (
            <div
              key={plano.id}
              className={`plano-card ${plano.destaque ? 'plano-card-destaque' : ''}`}
            >
              {plano.destaque && <div className="plano-tag-popular">Mais Popular</div>}

              <div className="plano-card-header">
                <h4 className="plano-card-titulo">{plano.nome}</h4>
                <p className="plano-card-preco">{plano.preco}</p>
              </div>

              <ul className="plano-card-recursos">
                {plano.recursos.map((recurso, idx) => (
                  <li key={idx}>
                    <span className="recurso-check-icon">✓</span>
                    {recurso}
                  </li>
                ))}
              </ul>

              <button
                className="plano-card-btn"
                onClick={() => {}}
              >
                Comprar
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* ── Footer simples ───────────────────────────────── */}
      <footer style={{
        padding: '24px',
        textAlign: 'center',
        borderTop: '1px solid #eee',
        color: '#aaa',
        fontSize: 13
      }}>
        © {new Date().getFullYear()} S6 Gestão · Todos os direitos reservados
      </footer>
    </div>
  );
}
